export default {
  templateDash_dashboards: {},
  templateDash_dashboardsInUse: []
}
